module.exports = __webpack_public_path__ + "static/media/banner-4.c2a9235a.png";